import React from 'react'
import ModernLevelIcon from './ModernLevelIcon'

// 기존 LevelIcon 인터페이스를 유지하면서 ModernLevelIcon 사용
const LevelIcon = ({ level }: { level: number }) => {
	return <ModernLevelIcon level={level} compact={true} />
}

export default React.memo(LevelIcon)
